import { _BasketAddMinimumBuy, type _BasketAddMinimumBuyParams, BasketAddMinimumBuy } from 'autogen/swagger/all';
import { BasketAddMinimumQuantityBuy } from 'components/basket/BasketAddMinimumQuantityBuy/BasketAddMinimumQuantityBuy';
import type { ConfirmationQuickViewAtom } from 'components/ConfirmationQuickView/shared/hooks';
import serverSideTracking from 'components/shared/productItem/shared/helpers';
import type { MediatorAtom } from 'hooks/globals/useMediatorAtom';
import { addToCartTypeEventCategoryMapper, GA4Tracking } from 'modules/tracking/GA4';
import type { ProductActionProps } from '../../shared/types';

type QuickViewToggleType = MediatorAtom<ConfirmationQuickViewAtom>['set'];

interface IAddMinimumQuantityProduct {
    toggle: QuickViewToggleType;
    handleConfirm: () => void;
    confirmText: string;
    denyText: string;
}

export async function openMinimumBuyConfirmModal(
    params: Omit<_BasketAddMinimumBuyParams, 'isQuickSearchContext'>,
    toggle: QuickViewToggleType,
    handleConfirm: () => void,
    confirmText: string,
    denyText: string
) {
    try {
        const data = await BasketAddMinimumBuy({ ...params, isQuickSearchContext: false });
        toggle({
            isOpen: true,
            options: {
                children: <BasketAddMinimumQuantityBuy model={data} />,
                confirmButtonStyle: 'primary',
                confirmText,
                onConfirm: handleConfirm,
                denyButtonStyle: 'secondary',
                denyText,
                onDeny: () => null
            }
        });
    } catch (error) {
        console.error(error);
    }
}

export default async function addMinimumQuantityProduct({
    params,
    trackingInfo,
    toggle,
    handleConfirm,
    confirmText,
    denyText
}: ProductActionProps['BuyMinimumNow'] & IAddMinimumQuantityProduct) {
    await openMinimumBuyConfirmModal(params, toggle, handleConfirm, confirmText, denyText);

    const GA4TrackingObject = addToCartTypeEventCategoryMapper(trackingInfo.eventCategory);

    if (params.minimumSalesQuantity) {
        GA4TrackingObject.eventParams?.push(
            {
                param_name: 'add_to_cart_quantity',
                param_value: params.minimumSalesQuantity
            },
            { param_name: 'is_minimum_quantity', param_value: true }
        );
    }

    GA4Tracking(GA4TrackingObject);

    if (trackingInfo.serverSideTrackingModel) {
        serverSideTracking(trackingInfo.serverSideTrackingModel.data, trackingInfo.serverSideTrackingModel.eventType);
    }
}
